import { styled as muiStyled } from '@mui/material'

export const A4PageMeasureComponent = muiStyled('div')(
  ({ theme }) => `
    @media print {
        display: none;
        }
`,
)

export const A4PageMeasureComponentWrapperContainer = muiStyled('div')(
  ({ theme, margin = 10, heightOfPage, a4Width = 794 }) => {
    // For patient history notes (heightOfPage === 0), allow height to be auto
    const effectiveHeight = heightOfPage === 0 ? 'auto' : `${heightOfPage}px`
    const effectiveMinHeight = heightOfPage === 0 ? 'auto' : `${heightOfPage}px`
    
    return `
    padding: ${margin}px;
    height: ${effectiveHeight};
    min-height: ${effectiveMinHeight};
    // border: 1px solid #000;
    display:flex;
    flex-direction:column;
    align-items:center;
    width: 100%;
    max-width: ${a4Width}px;
    box-sizing: border-box;
    position: relative;
    overflow: visible;
    
    /* Responsive: scale down when viewport is smaller than A4 width */
    @media (max-width: ${a4Width + 40}px) {
      max-width: 100% !important;
      width: 100% !important;
      min-width: 0 !important;
      padding: ${margin > 10 ? '8px' : margin}px !important;
      box-sizing: border-box !important;
    }
    
    /* Additional responsive breakpoint for medium screens */
    @media (max-width: 1000px) {
      max-width: 100% !important;
      width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box !important;
    }
    
    /* Mobile responsive */
    @media (max-width: 768px) {
      max-width: 100% !important;
      width: 100% !important;
      min-width: 0 !important;
      padding: 4px !important;
      height: auto !important;
      min-height: ${effectiveMinHeight};
      box-sizing: border-box !important;
    }
    
    @media print {
      padding: 0px !important;
      border: none !important;
      box-shadow: none !important;
      height: auto !important;
      min-height: ${effectiveMinHeight} !important;
      max-height: none !important;
      max-width: ${a4Width}px !important;
      width: ${a4Width}px !important;
      min-width: ${a4Width}px !important;
      margin: 0 !important;
      page-break-inside: avoid !important;
      overflow: visible !important;
      align-items: flex-start !important;
      justify-content: flex-start !important;
      position: relative !important;
      box-sizing: border-box !important;
      /* Prevent scaling */
      transform: none !important;
      -webkit-transform: none !important;
      zoom: 1 !important;
      scale: 1 !important;
    }
    
    /* Special handling for patient history notes - allow page breaks */
    .patient-history-notes-container & {
      @media print {
        page-break-inside: auto !important;
        break-inside: auto !important;
        height: auto !important;
        min-height: auto !important;
        max-height: none !important;
      }
    }
    `
  },
)

// @page {
//   size: A4 portrait; /* Or landscape */
//   margin: 1cm;
// }

// margin-top: ${noMargin ? 0 : 30}px;
export const A4PageContainer = muiStyled('div')(
  ({ theme, margin, divWidth, removePadding = false }) => `
  margin: ${removePadding ? 0 : '30px auto'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${removePadding ? `${divWidth}px` : `${divWidth + 60}px`};
  min-width: ${removePadding ? `${divWidth}px` : `${divWidth + 60}px`};
  max-width: ${removePadding ? `${divWidth}px` : `${divWidth + 60}px`};
  padding: ${removePadding ? 0 : 30}px;
  position: relative;
  overflow: visible;
  box-sizing: border-box;
  
  /* Responsive: scale down when viewport is smaller than container width */
  @media (max-width: ${removePadding ? divWidth + 40 : divWidth + 100}px) {
    width: calc(100% - 40px) !important;
    min-width: 0 !important;
    max-width: calc(100% - 40px) !important;
    padding: ${removePadding ? '0' : '15px'} !important;
    margin: ${removePadding ? 0 : '15px auto'} !important;
  }
  
  /* Additional responsive breakpoint for medium screens */
  @media (max-width: 1000px) {
    width: calc(100% - 20px) !important;
    min-width: 0 !important;
    max-width: calc(100% - 20px) !important;
    padding: ${removePadding ? '0' : '10px'} !important;
    margin: ${removePadding ? 0 : '10px auto'} !important;
  }
  
  /* Mobile responsive: scale down on small screens */
  @media (max-width: 768px) {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    padding: 8px !important;
    margin: 0 !important;
    transform: scale(1) !important;
    transform-origin: top center;
  }
  
  @media print {
    border: none !important;
    margin: 0px auto !important;
    padding: 0px !important;
    width: ${divWidth}px !important;
    min-width: ${divWidth}px !important;
    max-width: ${divWidth}px !important;
    align-items: flex-start !important;
    justify-content: flex-start !important;
    page-break-inside: avoid !important;
    page-break-after: always !important;
    box-sizing: border-box !important;
    position: relative !important;
    min-height: 0 !important;
    height: auto !important;
    overflow: visible !important;
    /* Prevent scaling */
    transform: none !important;
    -webkit-transform: none !important;
    zoom: 1 !important;
    scale: 1 !important;
  }
  
  /* Special handling for patient history notes - allow page breaks */
  .patient-history-notes-container & {
    @media print {
      page-break-inside: auto !important;
      break-inside: auto !important;
      page-break-after: auto !important;
      break-after: auto !important;
      height: auto !important;
      min-height: auto !important;
    }
  }
`,
)

export const A4CustomMarginsContainer = muiStyled('div')(
  ({ theme }) => `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 5px;
  width: 400px;
`,
)

export const A4WrapperContainer = muiStyled('div')(
  ({ theme, showInUI }) => `
  position: relative;
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  min-width: 0;
  
  @media print {
    position: static !important;
    width: 100% !important;
    height: auto !important;
    overflow: visible !important;
    /* Prevent scaling */
    transform: none !important;
    -webkit-transform: none !important;
    zoom: 1 !important;
    scale: 1 !important;
  }
`,
)

export const InchesPlaceHolderDivStyles = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    align-items:center;
    justify-content:center;
    border-left: 3px solid #4e2ff224;
    height: 100%;
    padding: 0 10px;
    background: #4e2ff22b;
`,
)

export const A4PageBackgroundContainer = muiStyled('div')(
  ({
    theme,
    width,
    height,
  }) => `
    width: ${width}px;
    height: ${height}px;
    background: #ffffff;
    box-shadow: 0 2px 8px #00000070;
    border: 1px solid #e0e0e0;
    margin: 20px auto;
    
    /* Mobile responsive: scale to fit screen width */
    @media (max-width: 768px) {
      width: 100% !important;
      height: auto !important;
      min-height: ${height}px;
      margin: 0 !important;
      box-shadow: none;
      border: none;
      transform: scale(1);
      transform-origin: top center;
    }
    
    @media print {
      box-shadow: none;
      border: none;
      margin: 0;
    }
`,
)
